import { useEffect, useState } from "react";
import {
  getCart,
  toggleCartDrawer,
  onCartDrawerChange,
} from "./Cart";

export default function HeaderCartIcon() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const updateCount = () => {
      const total = getCart().reduce((sum, item) => sum + item.quantity, 0);
      setCartCount(total);
    };

    const interval = setInterval(updateCount, 500); // basic polling for now
    updateCount(); // initial load

    return () => clearInterval(interval);
  }, []);

  return (
    <button
      className="cart-icon"
      onClick={toggleCartDrawer}
      title="View Cart"
      aria-label={`View cart. ${cartCount} item${cartCount !== 1 ? 's' : ''}`}
      aria-haspopup="dialog"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        width="28"
        height="28"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.5 6h13m-11.5-6L5.4 5M16 17a2 2 0 100 4 2 2 0 000-4zm-8 0a2 2 0 100 4 2 2 0 000-4z"
        />
      </svg>
      {cartCount > 0 && (
        <span className="cart-badge">{cartCount}</span>
      )}
    </button>
  );
}
